import React from 'react';
import Image from '../../../components/AppImage';

const TrustSignals = () => {
  const testimonials = [
  {
    company: 'TechCorp Solutions',
    logo: "https://img.rocket.new/generatedImages/rocket_gen_img_17b4dce52-1764654560254.png",
    logoAlt: 'TechCorp Solutions company logo with blue and white modern geometric design on transparent background',
    quote: 'CatalogFlip transformed how we present our product catalogs. The interactive features increased our engagement by 300%.',
    author: 'Sarah Mitchell',
    role: 'Marketing Director'
  },
  {
    company: 'Global Retail Inc',
    logo: "https://img.rocket.new/generatedImages/rocket_gen_img_1e3627a65-1767038842278.png",
    logoAlt: 'Global Retail Inc company logo featuring red shopping cart icon with bold black typography',
    quote: 'The VTEX integration made it seamless to connect our catalogs directly to our e-commerce platform. Game changer!',
    author: 'Michael Chen',
    role: 'E-commerce Manager'
  }];


  const stats = [
  { value: '50K+', label: 'Active Users' },
  { value: '2M+', label: 'Catalogs Created' },
  { value: '99.9%', label: 'Uptime SLA' },
  { value: '24/7', label: 'Support' }];


  return (
    <div className="space-y-6 md:space-y-8">
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
        {stats?.map((stat, index) =>
        <div key={index} className="text-center p-4 rounded-lg bg-muted/50">
            <div className="text-2xl md:text-3xl font-bold text-accent mb-1">{stat?.value}</div>
            <div className="text-xs md:text-sm text-muted-foreground">{stat?.label}</div>
          </div>
        )}
      </div>
      <div className="space-y-4">
        <h4 className="text-base md:text-lg font-semibold text-foreground">
          Trusted by leading businesses
        </h4>
        <div className="space-y-4">
          {testimonials?.map((testimonial, index) =>
          <div
            key={index}
            className="p-4 md:p-6 rounded-lg bg-card border border-border">

              <div className="flex items-center mb-3 md:mb-4">
                <div className="w-16 h-8 md:w-20 md:h-10 rounded overflow-hidden bg-muted flex items-center justify-center">
                  <Image
                  src={testimonial?.logo}
                  alt={testimonial?.logoAlt}
                  className="w-full h-full object-contain" />

                </div>
              </div>
              <p className="text-sm md:text-base text-muted-foreground italic mb-3 md:mb-4 leading-relaxed">
                "{testimonial?.quote}"
              </p>
              <div className="flex items-center">
                <div>
                  <div className="text-sm font-semibold text-foreground">{testimonial?.author}</div>
                  <div className="text-xs text-muted-foreground">{testimonial?.role}</div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>);

};

export default TrustSignals;